__webpack_require__.p = "/b/a/ouraring-business-site/v1.2.1/_next/";